export const QA_NAME_EMAIL_CREATION_MODAL = 'email_creation'
